import {tryJson} from '@helpers/common/json.mjs';
import {processValue} from '@components/product/global/tabs/TabHelpers';

export const SingleProductFocusTabs2Specifications = ({value}) => {
  let json = value;
  if (typeof value === 'string') {
    json = JSON.parse(value);
  }
  if (!json) {
    return null;
  }
  if (!('specs' in json)) {
    return;
  }
  return (
    <div id='Tab2Specifications'>
      {json?.specs?.map(({title, table}, index) => (
        <PropsCard key={index} title={title} table={table} />
      ))}
    </div>
  );
};

export const PropsCard = ({title, table}) => {
  const validProps = validKeys(table);
  if (!validProps?.length) {
    return null;
  }
  return (
    <div className={'pb-8 last:pb-0'}>
      <div
        className={
          'font-oswald tracking-widest uppercase border-b-2 pb-1 border-neutral-700 text-sm'
        }>
        {title}
      </div>
      <SingleTableSpecifications json={table} />
    </div>
  );
};

const sortInputBySeriesOrder = (validKeys) => {
  const seriesOrder = ['IX', 'VD', 'VS', 'SDR', 'SVR', 'DDX', 'EVL', 'VXF', 'ZVX'];
  const sortedKeys = seriesOrder?.filter((key) => validKeys.includes(key));
  const otherKeys = validKeys?.filter((key) => !seriesOrder.includes(key));
  return [...sortedKeys, ...otherKeys];
};

export const validKeys = (json) => {
  if (!json) {
    return [];
  }
  let validKeys = Object.keys(json);
  validKeys = validKeys?.filter((key) => {
    const value = json[key];

    const asJson = tryJson(value);
    if (asJson && Array.isArray(asJson)) {
      const validValues = asJson.filter(Boolean);
      if (!validValues.length) {
        return false;
      }
    }
    return value && value !== '--' && value !== 'N/A' && value !== null && value !== '?? R.Q. IVF';
  });
  if (!validKeys) {
    return [];
  }
  const sortedKeys = sortInputBySeriesOrder(validKeys);
  return sortedKeys;
};

const SingleTableSpecifications = ({json}) => {
  return (
    <dl className='divide-y divide-neutral-300 text-sm'>
      {validKeys(json).map((key) => {
        const title = key;
        const html = processValue(json[key]);
        return (
          <div
            key={key}
            className='grid grid-cols-1 gap-1 odd:bg-neutral-100 py-1 px-2 lg:py-2 sm:grid-cols-3 sm:gap-4 text-black'>
            <dt className='font-medium'>{title}</dt>
            <dd className='sm:col-span-2'>{html}</dd>
          </div>
        );
      })}
    </dl>
  );
};
